export default __webpack_public_path__ + "static/media/Audience Designer - Logo 1.a498cd54.png";